<!-- 基础开发管理平台首页 -->
<template>
  <el-container>
    <el-main>
      <basic-container class="table_div">
        <div class="
            width-p100
            bb-sm-primary
            mb-xxs
            ds-fx
            flex-direction-row
            justify-content-start
            align-items-center
          " style="padding-bottom: 2px">
          <i class="el-icon-document color-primary mr-sm"></i>
          <el-badge :value="page.total" :max="99" class="item" :hidden="page.total ? false : true">
            <el-button type="text">待批事项</el-button>
          </el-badge>
          <!-- <div
            style="margin-left:40px"
          >
            <el-button type="text" size="mini" @click="goPage('/xfjd/xfzc/xfyj/jsfwdb','技术服务待办')" style="font-size:15px;" v-if="jsfwShowObj.spShow != 0">技术服务待办</el-button>
            <el-button type="text" style="margin-left:20px;font-size:15px" size="mini" @click="goPage('/xfjd/xfzc/xfyj/yjts','技术服务提醒')" v-if="jsfwShowObj.yjShow != 0">技术服务提醒</el-button>
          </div> -->
          <div class="refsh-item">
            <el-input size="mini" placeholder="请输入标题" v-model="search.todoTitle" style="width: 200px;margin-right: 30px;" @keyup.enter.native="refshClick(1,'refreshDpsxStatus','todoTitle',true)"><i slot="suffix" class="el-input__icon el-icon-search" @click="refshClick(1,'refreshDpsxStatus','todoTitle',true)"></i></el-input>
            <span @click="refshClick(1,'refreshDpsxStatus','todoTitle')">
              <span v-if="!refreshDpsxStatus"><i class="el-icon-refresh"></i>刷新</span>
              <span v-else>刷新中...</span>
            </span>
          </div>
        </div>
        <div>
          <avue-crud :option="option" :data="tableData">
            <template slot="empty">
              <div desc="无数据"></div>
            </template>
            <template slot="menu" slot-scope="{ row }">
              <el-button v-for="(item, index) in row.BTN_LIST || []" size="mini" type="text" :key="index" @click.stop="handleDB(item, row)">
                <span v-text="item.BUTTON_NAME"></span>
              </el-button>
              <!-- <el-button type="text" size="mini" @click="deletedDbClick(row)"><i class="el-icon-close" style="color:red;margin-left:10px"></i></el-button> -->
            </template>
            <template slot="status" slot-scope="{ row }">
              <p v-if="row.REM_DAYS == 0" style="color: #E6A23C">
                <i class="el-icon-s-opportunity"></i>
                截止日
              </p>
              <p v-else-if="Number(row.REM_DAYS)< 0" style="color: red">
                <i class="el-icon-s-opportunity"></i>
                超<span v-text="Math.abs(Number(row.REM_DAYS))"></span>日
              </p>
              <p v-else-if="Number(row.REM_DAYS)> 0" style="color: green">
                <i class="el-icon-s-opportunity"></i>
                剩<span v-text="row.REM_DAYS"></span>日
              </p>
              <p v-else></p>
            </template>
          </avue-crud>
          <div class="block">
            <p v-text="
                `总数${page.total}，共${page.pages}页，当前为第${page.currentPage}页，每页${page.pageSize}条`
              "></p>
            <el-pagination @current-change="needCurrentChange" @size-change="needSizeChange" :current-page="page.currentPage" :page-sizes="[5, 10, 20, 50, 100, 200, 500, 1000]" :page-size="page.pageSize" layout="total,sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>
      </basic-container>
      <basic-container class="table_div">
        <div class="
            width-p100
            bb-sm-primary
            mb-xxs
            ds-fx
            flex-direction-row
            justify-content-start
            align-items-center
          " style="padding-bottom: 2px">
          <i class="el-icon-document color-primary mr-sm"></i>
          <el-badge :value="methodPage.total" :max="99" class="item" :hidden="methodPage.total ? false : true">
            <el-button type="text">工作提醒</el-button>
          </el-badge>
          <el-checkbox v-model="gztxChecked" style="margin-left:50px">含本人协办任务</el-checkbox>
          <div class="refsh-item">
          <el-input size="mini" placeholder="请输入标题" v-model="search.gztxTitle" style="width: 200px;margin-right: 30px;" @keyup.enter.native="refshClick(2,'refreshGztxStatus','gztxTitle',true)"><i slot="suffix" class="el-input__icon el-icon-search" @click="refshClick(2,'refreshGztxStatus','gztxTitle',true)"></i></el-input>
            <span @click="refshClick(2,'refreshGztxStatus','gztxTitle')">
              <span v-if="!refreshGztxStatus"><i class="el-icon-refresh"></i>刷新</span>
              <span v-else>刷新中...</span>
            </span>
          </div>
        </div>
        <div>
          <avue-crud :option="option1" :data="tableData1">
            <template slot="empty">
              <div desc="无数据"></div>
            </template>
            <template slot="menu" slot-scope="{ row }">
              <el-button size="mini" type="text" @click.stop="handleTX(row.BTN_LIST[0].BUTTON_TYPE)">
                <span v-text="row.BTN_LIST[0].BUTTON_NAME"></span>
              </el-button>
              <!-- <el-button type="primary" icon="el-icon-edit" size="small"></el-button> -->
            </template>
            <template slot="status" slot-scope="{ row }">
              <p v-if="row.REM_DAYS == 0" style="color: #E6A23C;">
                <i class="el-icon-s-opportunity"></i>
                截止日
              </p>
              <p v-else-if="Number(row.REM_DAYS)> 0" style="color: #67C23A;">
                <i class="el-icon-s-opportunity"></i>
                剩<span v-text="row.REM_DAYS"></span>日
              </p>
              <p v-else-if="row.CQTXLX!=1||row.TXLX==9">(仅提醒)</p>
              <p v-else-if="Number(row.REM_DAYS)< 0" style="color: #F56C6C;">
                <i class="el-icon-s-opportunity"></i>
                超<span v-text="Math.abs(Number(row.REM_DAYS))"></span>日
              </p>
              <p v-else></p>
            </template>
            <template slot="TITLE" slot-scope="{ row }">
              <p @click="methodClick(row)" style="cursor:pointer">
                <span v-text="row.TITLE" style="color: #2E5AE8"></span>
              </p>
            </template>
            <template slot="BTN" slot-scope="{ row }">
              <el-button type="text" v-for="item in row.BTN_LIST" size="mini" :key="item.ID" v-text="item.BUTTON_NAME" @click="toPage(row,item)"></el-button>
              <el-button type="text" size="mini" @click="deletedsClick(row)"><i class="el-icon-close" style="color:red;margin-left:10px"></i></el-button>
            </template>
          </avue-crud>
          <div class="block">
            <p v-text="
                `总数${methodPage.total}，共${methodPage.pages}页，当前为第${methodPage.currentPage}页，每页${methodPage.pageSize}条`
              "></p>
            <el-pagination @current-change="methodCurrentChange" @size-change="methodSizetChange" :current-page="methodPage.currentPage" :page-sizes="[5, 10, 20, 50, 100, 200, 500, 1000]" :page-size="methodPage.pageSize" layout="total,sizes, prev, pager, next, jumper" :total="methodPage.total">
            </el-pagination>
          </div>
        </div>
      </basic-container>
      <basic-container class="table_div">
        <div class="
            width-p100
            bb-sm-primary
            mb-xxs
            ds-fx
            flex-direction-row
            justify-content-start
            align-items-center
          " style="padding-bottom: 2px">
          <i class="el-icon-document color-primary mr-sm"></i>
          <el-badge :value="unfinishedPage.total" :max="99" class="item" :hidden="unfinishedPage.total ? false : true">
            <el-button type="text">本人未结任务</el-button>
          </el-badge>
          <el-checkbox v-model="checked" style="margin-left:50px">含本人协办任务</el-checkbox>
          <div class="refsh-item">
          <el-input size="mini" placeholder="请输入标题" v-model="search.wjrwTitle" style="width: 200px;margin-right: 30px;" @keyup.enter.native="refshClick(3,'refreshWjrwStatus','wjrwTitle',true)"> <i slot="suffix" class="el-input__icon el-icon-search" @click="refshClick(3,'refreshWjrwStatus','wjrwTitle',true)"></i></el-input>
            <span @click="refshClick(3,'refreshWjrwStatus','wjrwTitle')">
              <span v-if="!refreshWjrwStatus"><i class="el-icon-refresh"></i>刷新</span>
              <span v-else>刷新中...</span>
            </span>
          </div>
        </div>
        <div>
          <el-tabs v-model="wjrwActiveName" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="所有任务" name="-1">
              <span slot="label"><i class="el-icon-date"></i>{{`所有任务(${total['-1']||0})`}}</span>
            </el-tab-pane>
          </el-tabs>
          <avue-crud :option="optionRW[wjrwActiveName]" :data="tableDataRW">
            <template slot="RWMC" slot-scope="{row}">
              <el-button size="mini" type="text" @click="getDetailByXMMC(row)">
                <span v-text="row.RWMC"></span>
              </el-button>
              <span v-if="row.RWJG==1" style="color:#67C23A;">[合格]</span>
              <span v-else-if="row.RWJG==2" style="color:#F56C6C;">[不合格]</span>
              <span v-else-if="row.RWJG==3" style="color:#67C23A;">[复查合格]</span>
              <span v-else-if="row.RWJG==4" style="color:#F56C6C;">[复查不合格]</span>
            </template>
            <template slot="RWMCANDLX" slot-scope="{row}">
              <el-button size="mini" type="text" @click="getDetailByXMMC(row)">
                <span v-text="row.RWMCANDLX"></span>
              </el-button>
              <span v-if="row.RWJG==1" style="color:#67C23A;">[合格]</span>
              <span v-else-if="row.RWJG==2" style="color:#F56C6C;">[不合格]</span>
              <span v-else-if="row.RWJG==3" style="color:#67C23A;">[复查合格]</span>
              <span v-else-if="row.RWJG==4" style="color:#F56C6C;">[复查不合格]</span>
            </template>
            <template slot="DWMC" slot-scope="{row}">
              <el-button size="mini" type="text" @click="getDetailByXMMC(row)">
                <span v-text="row.DWMC"></span>
              </el-button>
              <span v-if="row.RWJG==1" style="color:#67C23A;">[合格]</span>
              <span v-else-if="row.RWJG==2" style="color:#F56C6C;">[不合格]</span>
              <span v-else-if="row.RWJG==3" style="color:#67C23A;">[复查合格]</span>
              <span v-else-if="row.RWJG==4" style="color:#F56C6C;">[复查不合格]</span>
            </template>
            <template slot="LYBH" slot-scope="{row}">
              <!-- <el-button size="mini" type="text" @click="getWSByLYBH(row)"> -->
                <span v-text="row.LYBH"></span>
              </el-button>
            </template>
            <template slot="TSLYBH" slot-scope="{row}">
              <!-- <el-button size="mini" type="text" @click="getWSByLYBH(row)"> -->
                <span v-text="row.TSLYBH"></span>
              </el-button>
            </template>
            <template slot="JZRQ" slot-scope="{row}">
              <span v-html="row.BLQX"></span>
            </template>
            <template slot="RWLX" slot-scope="{row}">
              <span>{{row.FCNAME || row.RWLXMC}}</span>
            </template>
            <template slot="RWZT" slot-scope="scope">
              <span :style="{color:findArr(scope.dic||[],'dictKey',scope.row.RWZT,'color')}" v-text="scope.row.$RWZT"></span>
            </template>
          </avue-crud>
          <div class="block">
            <span v-text="
                `总数${unfinishedPage.total}，共${unfinishedPage.pages}页，当前为第${unfinishedPage.currentPage}页，每页${unfinishedPage.pageSize}条`
              "></span>
            <el-pagination @current-change="handleRWCurrentChange" @size-change="handleRWSizeChange" :current-page="unfinishedPage.currentPage" :page-size="unfinishedPage.pageSize" :page-sizes="[5, 10, 20, 50, 100, 200, 500, 1000]" layout="total,sizes, prev, pager, next, jumper" :total="unfinishedPage.total">
            </el-pagination>
          </div>
        </div>
      </basic-container>
    </el-main>
    <el-aside width="240px" height="100%">
      <el-card class="box-card">
        <div slot="header" class="clearfix box_top">
          <span><i class="el-icon-s-promotion"></i>通知通告</span>
          <span @click="onLoadFbtzData" class="onload">
            <span><i class="el-icon-refresh"></i>刷新</span>
          </span>
        </div>
        <crt-time-rang v-model="CRT_TIME" @dateChange="dateChange"></crt-time-rang>
        <el-row style="margin-top:30px" v-loading="fbtzLoading">
          <template v-if="fbtzData.length > 0">
            <div class="pUserShortcut" v-for="(item, index) in fbtzData" :key="index" @click="getFile(item)">
              <el-tooltip :disabled="item.TITLE.length<17" class="item" effect="dark" :content="item.TITLE" placement="top-start">
                <div class="tooplTip text-height" style="color:#2e5ae8">
                  <i class="el-icon-caret-right" style="font-size:16px"></i>{{ item.TITLE }}
                </div>
              </el-tooltip>
            </div>
          </template>
          <el-row v-else class="empty">
            <i class="el-icon-circle-close icon"></i><br>
            暂无通知通告
          </el-row>
        </el-row>
        <el-row style="height:30px;text-align:center" v-if="fbtzTotal > 0">
          <el-pagination
            style="width:100%"
            small
            layout="prev, pager, next"
            :total="fbtzTotal"
            :pager-count="4"
            hide-on-single-page
            :current-page="currentPage"
            @current-change="currentChange"
            @prev-click="currentChange"
            @next-click="currentChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-s-promotion"></i>快捷方式</span>
        </div>
        <div class="pUserShortcut" v-for="(item, index) in pUserShortcutData" :key="index" @click="pUserShortcutClick(item.opId, item.opName,item)">
          <el-tooltip :disabled="item.opName.length<17" class="item" effect="dark" :content="item.opName" placement="top-start">
            <div class="tooplTip text-height">
              <svg class="icon svg-icon" aria-hidden="true" style="font-size: 18px">
              <use :xlink:href="item.source"></use>
              </svg>
              {{ item.opName }}
            </div>
          </el-tooltip>
          </div>
        <div class="pUserShortcutClear"></div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-question"></i>帮助</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text" @click="gotoHelpPage">更多>></el-button> -->
        </div>
        <div style="overflow-y: auto; height:190px;" v-loading="bzscLoading">
          <!-- <p v-for="(it,i) in bzsc" :key="i">
            <el-button type="text" style="padding: 0;" class="fs-sm text-height" @click="openUrl(it)" v-text="`${i+1}、${it.name}`"></el-button>
          </p> -->
          <p v-for="(it,i) in bzscList" :key="i">
            <el-button type="text" style="padding: 0;" class="fs-sm text-height" @click="openscUrl(it)">{{ `${i+1}、${it.TITLE}` }}</el-button>
          </p>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-question"></i>注意事项</span>
        </div>
        <div class="color-theadC fs-sm">

        </div>
      </el-card>
    </el-aside>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { filterArr } from "@/util/util";
import { getShow } from '@/api/table/table';
import { pUserShortcut } from "@/api/home/home";
import { getDictionary } from "@/api/system/dict";
import { usualGetFileList } from "@/api/system/file";
import { getUnfinishedTask } from "@/api/xfjd/index";
import { getList, saveOpRunLog } from "@/api/system/public";
import { getDataByDataId, download, post, deleteShow } from "@/api/table/table";
import { dateFormat } from "@/util/date";
import crtTimeRang from '@/components/component/crtTimeRang';
export default {
  components: {
    crtTimeRang
  },
  data() {
    //这里存放数据
    return {
      search: {
        todoTitle: '',
        dpsxTitle: '',
        wjrwTitle: '',
      },
      resRWFL: [],
      checked: false,
      gztxChecked: false,
      Alltable: [],//本人未结任务数据--克隆
      tableData: [], // 待办数据
      tableData1: [], // 提醒事项数据
      tableDataRW: [], // 本人未结任务数据
      pUserShortcutData: [], // 快捷方式数据
      fbtzData: [], // 发布通知数据
      rwlxArr: [], // 任务类型字典数据
      bzsc: [
        {
          url: "ed7a4766088608fae7720555b7ceca73",
          name: "系统管理员手册"
        },
        {
          url: "jdjc",
          name: "消防监督手册"
        },
        {
          url: "aqjc",
          name: "安全检查手册"
        },
        {
          url: "cpjd",
          name: "产品监督手册"
        },
        {
          url: "hzdc",
          name: "火灾调查手册"
        },
        {
          url: "jsfw",
          name: "技术服务手册"
        },
        {
          url: "cxtj",
          name: "查询统计手册"
        },
        {
          url: "flfg",
          name: "法律法规手册"
        },
        {
          url: "fljj",
          name: "法律救济手册"
        },
        {
          url: "jcxx",
          name: "基础信息手册"
        },
        {
          url: "ssj",
          name: "双随机手册"
        },
        {
          url: "sygk",
          name: "信用公开手册"
        },
        {
          url: "xzcf",
          name: "行政处罚手册"
        },
        {
          url: "xzqz",
          name: "行政强制手册"
        },
        {
          url: "ydd",
          name: "移动端手册"
        },
        {
          url: "zfjd",
          name: "执法监督手册"
        },
      ], // 帮助手册
      bzscList: [],
      bzscLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        pages: 0
      },
      methodPage: {
        pageSize: 5,
        total: 0,
        currentPage: 1,
        pages: 0
      },
      unfinishedPage: {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        pages: 0
      },
      option: {
        menu: true, // 菜单
        border: true,
        menuWidth: 80,
        align: "center", // 居中
        header: false,
        stripe: true,
        editBtn: false,
        delBtn: false,
        column: [
          {
            prop: "TITLE",
            label: "标题",
            width: 500,
            align: "left",
            overHidden: true
          },
          {
            prop: "FROMACCNAME",
            label: "来源",
          },
          {
            prop: "FROMTIME",
            type: "datetime",
            label: "送达日期",
            format: "yyyy-MM-dd HH:mm",
            width: 125
          },
          {
            prop: "status",
            label: "状态",
            slot: true
          },
          {
            prop: "INFOTYPE",
            label: "类型",
            dicData: [
              // { value: "1", label: "流转" },
              // { value: "2", label: "退回" },
              // { value: "3", label: "批复" },
              // { value: "4", label: "修订" },
              // { value: "5", label: "主办" },
              // { value: "6", label: "协办" },
              // { value: "7", label: "接收" },
              // { value: "8", label: "确认" },
              { value: "1", label: "审核" },  // 苏冬玲说的 杨哥让改成下面的
              { value: "2", label: "法核" },
              { value: "3", label: "审批" },
              { value: "7", label: "退回" },
              { value: "8", label: "确认" },
              { value: "9", label: "批阅" },
            ]
          }
        ]
      },
      option1: {
        align: "center",
        border: true,
        header: false,
        overHidden: true,
        menuWidth: 90,
        stripe: true,
        menu: false,
        column: [
          {
            prop: "TITLE",
            label: "标题",
            // width:420,
            minWidth: 300,
            maxWidth: 400,
            slot: true,
            align: "left",
            overHidden: true
          },
          {
            prop: "TXKSSJ",
            label: "起始日期",
            width: 100,
            type: "datetime",
            format: "yyyy-MM-dd"
          },
          {
            prop: "TXJSSJ",
            label: "截止日期",
            width: 100,
            type: "datetime",
            format: "yyyy-MM-dd"
          },
          {
            prop: "status",
            label: "状态",
            width: 100,
            slot: true
          },
          {
            prop: "CBRXM",
            label: "承办人",
            minWidth: 100,
            maxWidth: 160
          },
          {
            prop: "BTN",
            label: "操作",
            slot: true,
            flex:"right",
          }
        ]
      },
      optionRW: {
        "-1": {
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "RWMC",
              label: "任务名称",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "JHKSRQ",
              label: "起始日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "JZRQ",
              label: "办理期限",
              minWidth: 100,
              slot: true,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "RWLX",
              label: "任务类型",
              minWidth: 100,
              dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_SYS_RWZLX`,
              props: {
                label: "dictValue",
                value: "dictKey"
              },
              slot: true
            },
            {
              prop: "CBRXM",
              label: "主承办人",
              minWidth: 100
            },
            {
              prop: "XBRXM",
              label: "协承办人",
              minWidth: 130,
              overHidden: true
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
        "1": {//监督检查
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "DWMC",
              label: "单位名称",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "YDJCQX",
              label: "预定检查日期",
              minWidth: 130,
              format: "yyyy-MM-dd"
            },
            {
              prop: "SJKSRQ",
              label: "检查日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "RWLX",
              label: "检查类型",
              minWidth: 160,
              dicData: [],
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            },
            {
              prop: "CBRXM",
              label: "主承办人",
              minWidth: 100
            },
            {
              prop: "XBRXM",
              label: "协承办人",
              minWidth: 130,
              overHidden: true
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
        "2": {//安全检查
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "DWMC",
              label: "单位名称",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "XMCSMC",
              label: "场所名称",
              minWidth: 240,
              align: "left",
              overHidden: true
            },
            {
              prop: "SLRQ",
              label: "受理日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "JHJSRQ",
              label: "截止日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "RWJCRQ",
              label: "检查日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "CBRXM",
              label: "主承办人",
              minWidth: 100
            },
            {
              prop: "XBRXM",
              label: "协承办人",
              minWidth: 130,
              overHidden: true
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
        "3": {//产品监督
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "DWMC",
              label: "单位名称",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "YDJCQX",
              label: "预定检查日期",
              minWidth: 140,
              format: "yyyy-MM-dd"
            },
            {
              prop: "SJJSRQ",
              label: "检查日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "RWLXMC",
              label: "任务类型",
              minWidth: 100,
            },
            {
              prop: "ZXCBRXM",
              label: "承办人",
              minWidth: 250
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
        "4": {//技术服务
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "DWMC",
              label: "单位名称",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "YDJCQX",
              label: "预定检查日期",
              minWidth: 130,
              format: "yyyy-MM-dd"
            },
            {
              prop: "SJKSRQ",
              label: "检查日期",
              minWidth: 100,
              slot: true,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "RWLX",
              label: "检查类型",
              minWidth: 100,
              dicData: [],
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            },
            {
              prop: "CBRXM",
              label: "主承办人",
              minWidth: 100
            },
            {
              prop: "XBRXM",
              label: "协承办人",
              minWidth: 130,
              overHidden: true
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
        "5": { //火调
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "RWMC",
              label: "起火对象",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "JHKSRQ",
              label: "报警日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "JZRQ",
              label: "截止日期",
              minWidth: 100,
              slot: true,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "SJKSRQ",
              label: "处理日期",
              minWidth: 100,
              // slot:true,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "CBRXM",
              label: "主承办人",
              minWidth: 100
            },
            {
              prop: "XBRXM",
              label: "协承办人",
              minWidth: 130,
              overHidden: true
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
        "6": {//行政处罚
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "RWMCANDLX",
              label: "处罚对象",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "TSLYBH",
              label: "受案登记表",
              minWidth: 200,
              slot: true,
              align: "left",
            },
            {
              prop: "JHKSRQ",
              label: "受案日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "JHJSRQ",
              label: "办案期限",
              minWidth: 160,
              format: "yyyy-MM-dd"
            },
            {
              prop: "CBRXM",
              label: "主承办人",
              minWidth: 100
            },
            {
              prop: "XBRXM",
              label: "协承办人",
              minWidth: 130,
              overHidden: true
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
        "7": {//行政强制
          align: "center",
          border: true,
          header: false,
          menu: false,
          editBtn: false,
          delBtn: false,
          stripe: true,
          column: [
            {
              prop: "RWMC",
              label: "行政强制对象",
              minWidth: 240,
              slot: true,
              align: "left",
              overHidden: true
            },
            {
              prop: "LYBH",
              label: "法律文书",
              minWidth: 200,
              slot: true,
              align: "left",
            },
            {
              prop: "RWJCRQ",
              label: "行政强制日期",
              minWidth: 100,
              type: "datetime",
              format: "yyyy-MM-dd"
            },
            {
              prop: "YDJCQX",
              label: "行政强制期限",
              minWidth: 160,
              format: "yyyy-MM-dd"
            },
            {
              prop: "RWLX",
              label: "行政强制类型",
              minWidth: 100,
              dicData: [],
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            },
            {
              prop: "CBRXM",
              label: "主承办人",
              minWidth: 100
            },
            {
              prop: "XBRXM",
              label: "协承办人",
              minWidth: 130,
              overHidden: true
            },
            {
              prop: "RWZT",
              label: "任务状态",
              minWidth: 80,
              // dicUrl: `/api/blade-system/dict/dictionary?code=XFJD_XMRW_ZRWZT`,
              dicData: [],
              slot: true,
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }
          ]
        },
      },
      tabName: "all", //点击的tab
      total: {},  //各类未结任务数
      wjrwActiveName: "-1", // 未结任务默认名称
      jsfwObj: {
        spTotal: "",
        yjTotal: ""
      },
      jsfwShowObj: {
        spShow: 0,
        yjShow: 0
      },
      refreshDpsxStatus: false,
      refreshGztxStatus: false,
      refreshWjrwStatus: false,
      firstEnter: true,
      fbtzLoading: false,
      CRT_TIME:"",
      fbtzTotal:0,
      currentPage:1
    };
  },
  //监听属性 类似于data概念
  computed: { ...mapGetters(["userInfo", "setIp"]) },
  //监控data中的数据变化
  watch: {
    checked(val) {
      this.onLoadTask()
      this.onLoadRW('wjrwTitle',true)
    },
    gztxChecked(val) {
      this.onLoadMethod('gztxTitle',true);
    }
  },
  //方法集合
  methods: {
    //搜索
    searchData(title) {},
    // 待办行按钮点击
    handleDB(btn, row) {
      console.log(btn, row);
      console.log(btn.BUTTON_TYPE);
      if (btn.BUTTON_TYPE == "divideWork" || btn.BUTTON_TYPE == "deliver") {// 分工
        this.$router.push({
          path: "/xfjd/sendDivision",
          query: {
            runId: this.userInfo.runId,
            lzid: row.LZID,
            parentName: "首页",
            FLWSLB: row.FLWSLB,
            path: this.$route.path
          }
        })
      } else if (btn.BUTTON_TYPE == "jdjcghcbr") { // 监督检查更换承办人
        this.$router.push({
          path: "/xfjd/sendDivision",
          query: {
            runId: this.userInfo.runId,
            lzid: row.LZID,
            parentName: "首页",
            path: this.$route.path
          }
        });
      } else if (btn.BUTTON_TYPE == "sign") { // 审批 确认
        this.$router.push({
          path: "/xfjd/approval",
          query: {
            runId: this.userInfo.runId,
            lzid: row.LZID,
            flwslb: row.FLWSLB,
            parentName: "首页",
            type: 6,
            path: this.$route.path,
            PROCID:row.PROCID,
            dbtype: row.DBTYPE||"0"
          }
        });
      }
      else if (btn.BUTTON_TYPE == "bash"){ //备案审核
        this.$router.push({
          path: "/xfjd/cpjd/flfgbzgl/approval",
          query: {
            runId: this.userInfo.runId,
            lzid: row.LZID,
            parentName: "首页",
            type: 6,
            path: this.$route.path,
            FLWSID:row.FLWSID,
            FROMACCNAME:row.FROMACCNAME,
            FROMTIME:row.FROMTIME,
            FROMACCID:row.FROMACCID,
            ID:row.ID
          }
        });
      }else if(btn.BUTTON_TYPE == 'px'||btn.BUTTON_TYPE == 'sh'){
        this.$router.push({
          path: "/xfjd/cpjd/jcxx/zsk/shqk/approval",
          query: {
            runId: this.userInfo.runId,
            lzid: row.LZID,
            parentName: "首页",
            path: this.$route.path,
            FLWSID:row.FLWSID,
            FROMACCNAME:row.FROMACCNAME,
            FROMTIME:row.FROMTIME,
            FROMACCID:row.FROMACCID,
            ID:row.ID,
            FLWSLB:row.FLWSLB
          }
        });
      }
      else {  // 其他
        this.$router.push({
          path: "/xfjd/approval",
          query: {
            runId: this.userInfo.runId,
            lzid: row.LZID,
            parentName: "首页",
            flwslb: row.FLWSLB,
            path: this.$route.path,
            PROCID:row.PROCID,
            dbtype: row.DBTYPE||"0"
          }
        });
      }
      // pLzspFgInfo(this.$qs.stringify({lzid:row.LZID,runId:res.data.data})).then(res=>{
      //   console.log(res.data.data);
      // },err=>{}).catch((err) => {console.log( err )})
    },
    // 初次加载所有
    onLoad() {
      console.log("加载所有");
      this.onLoadNeed();// 加载待办
      this.onLoadMethod();// 加载提醒事项
      this.onLoadShortcut();// 加载快捷方式
      this.onLoadFbtz();// 加载发布通知
      // this.onLoadRW();//加载本人未结任务
      // this.onLoadTask();//加载未结任务统计数据
    },
    // 跳转帮助页面
    gotoHelpPage() {
      this.$router.push({
        path: "/system/helpView",
        query: {
          runId: this.userInfo.runId,
        },
      });
    },
    // 数组渲染
    findArr(arr, key, value, re) {
      return filterArr(arr, key, value, re);
    },
    // 加载待办
    async onLoadNeed(title,refresh) {
      console.log(this.search)
      if(refresh) this.page.currentPage = 1
      await getDataByDataId(this.page.currentPage, this.page.pageSize, {
        dataId: 1,
        queryFields: {TITLE: this.search.todoTitle},
        descs: "FROMTIME"
      }).then(res => {
        let data = res.data.data.data;
        this.tableData = data.records;
        if (data.size === undefined || data.size === null) {
          data.size = ''
        }
        if (data.total === undefined || data.total === null) {
          data.total = ''
        }
        if (data.current === undefined || data.current === null) {
          data.current = ''
        }
        if (data.pages === undefined || data.pages === null) {
          data.pages = ''
        }
        this.page = {
          pageSize: data.size,
          total: data.total,
          currentPage: data.current,
          pages: data.pages
        };
      }).catch((err) => { console.log(err) });
      // get("/api/blade-xfjd/api/jsfwApi/getJsfwTotal",{}).then(res => {console.log(res);}).catch((err) => {console.log( err )})
    },
    // 加载提醒事项
    async onLoadMethod(title,refresh) {
      if(refresh) this.methodPage.currentPage = 1
      await getDataByDataId(this.methodPage.currentPage, this.methodPage.pageSize, {
        dataId: 2,
        queryFields: {
          CBLX: this.gztxChecked ? '1,2' : '1',
          TITLE: this.search.gztxTitle
        }
      }).then(res => {
        let data = res.data.data.data;
        this.tableData1 = data.records;
        if (data.size === undefined || data.size === null) {
          data.size = ''
        }
        if (data.total === undefined || data.total === null) {
          data.total = ''
        }
        if (data.current === undefined || data.current === null) {
          data.current = ''
        }
        if (data.pages === undefined || data.pages === null) {
          data.pages = ''
        }
        this.methodPage = {
          pageSize: data.size,
          total: data.total,
          currentPage: data.current,
          pages: data.pages
        };
      }).catch((err) => { console.log(err) });
    },
    // 加载快捷方式
    onLoadShortcut() {
      pUserShortcut(
        this.$qs.stringify({
          count: '10'
        })
      ).then(
        res => {
          this.loading = false;
          this.pUserShortcutData = res.data.data;
        },
        e => {
          this.loading = false;
        }
      ).catch((err) => { console.log(err) });
    },
    // 加载发布通知
    onLoadFbtz(currentpage) {
      this.fbtzLoading = true;
      // 初始化时间
      if(!this.CRT_TIME){
        // 获取7天数据
        let time = dateFormat(new Date(),"yyyy-MM-dd 23:59:59"),oldTime = dateFormat(new Date(new Date().getTime() - 7*24*60*60*1000),"yyyy-MM-dd 00:00:00");
        this.CRT_TIME = oldTime+ "," +time;
      }
      getShow(currentpage || 1,10,this.userInfo.runId,{
        obj: {CRT_TIME:this.CRT_TIME},
        opid: 3767
      }).then(data => {
        console.log(data);
        this.fbtzData = data.data.data.records;
        this.fbtzTotal = data.data.data.total;
        this.fbtzLoading = false;
      },error => {})
    },
    // 点击刷新加载数据
    onLoadFbtzData(){
      this.CRT_TIME = "";
      this.currentPage = 1;
      this.onLoadFbtz();
    },
    // 选择时间重新加载数据
    dateChange(value){
      this.CRT_TIME = value.join(",");
      this.currentPage = 1;
      this.onLoadFbtz();
    },
    // 选择页数重新获取接口
    currentChange(current){
      this.currentPage = current;
      this.onLoadFbtz(current);
    },
    // 加载发布通知的附件
    getFile(item){
      this.$router.push({
        path:"/xfjd/xtsy/fbtzAdd",
        query:{
          runId:this.userInfo.runId,
          ID:item.ID,
          name:"发布通知查看",
          pageType: '3'
        }
      })
    },
    //加载本人未结任务
    // async onLoadRW(title,refresh) {
    //   if(refresh) this.unfinishedPage.currentPage = 1
    //   try {
    //     let res = await post("/api/blade-xfjd/api/base/getRwlx", {
    //       rwzlx: this.wjrwActiveName,
    //       cblx: this.checked ? '-1' : '1,3',
    //       rwzt: "!7",
    //     })
    //     this.rwlxArr=res.data.data;
    //   } catch { }

    //   await getDataByDataId(
    //     this.unfinishedPage.currentPage,
    //     this.unfinishedPage.pageSize,
    //     {
    //       dataId: 3, queryFields: {
    //         RWZLX: this.wjrwActiveName,
    //         CBLX: this.checked ? '-1' : '1,3',
    //         RWZT: "!7",
    //         RWMC: this.search.wjrwTitle
    //       }
    //     }
    //   ).then(res => {
    //     const data = res.data.data.data;
    //     this.tableDataRW = data.records;
    //     this.tableDataRW.forEach(item => {
    //       this.resRWFL.forEach(item1 => {
    //         if (item.RWZLX == item1.dictKey) {
    //           item.RWZLXMC = item1.dictValue
    //         }
    //       })
    //     })
    //     if (data.size === undefined || data.size === null) {
    //       data.size = ''
    //     }
    //     if (data.total === undefined || data.total === null) {
    //       data.total = ''
    //     }
    //     if (data.current === undefined || data.current === null) {
    //       data.current = ''
    //     }
    //     if (data.pages === undefined || data.pages === null) {
    //       data.pages = ''
    //     }
    //     this.unfinishedPage = {
    //       pageSize: data.size,
    //       total: data.total,
    //       currentPage: data.current,
    //       pages: data.pages
    //     };
    //   }).catch((err) => { console.log(err) });
    // },
    //加载未结任务统计数据
    // async onLoadTask() {
    //   var obj = {}
    //   this.checked ? obj = { countGroup: "-1|1|2|3|4|5|6|7", cblx: "1,2,3", rwzt: "!7", } : obj = { countGroup: "-1|1|2|3|4|5|6|7", cblx: "1,3", rwzt: "!7" }
    //   let res = await getUnfinishedTask(obj);
    //   this.total = res.data.data;
    // },
    // 待办翻页
    needCurrentChange(val) {
      this.page.currentPage = val;
      this.onLoadNeed('todoTitle');
    },
    // 待办翻页
    needSizeChange(val) {
      this.page.pageSize = val;
      this.onLoadNeed('todoTitle');
    },
    // 提醒事项翻页
    methodCurrentChange(val) {
      this.methodPage.currentPage = val;
      console.log(this.methodPage,'methodPage',val)
      this.onLoadMethod('gztxTitle');
    },
    // 提醒事项翻页
    methodSizetChange(val) {
      this.methodPage.pageSize = val;
      this.onLoadMethod('gztxTitle');
    },
    //本人未结任务翻页
    handleRWCurrentChange(val) {
      this.unfinishedPage.currentPage = val;
      this.onLoadRW('wjrwTitle');
    },
    //本人未结任务翻页
    handleRWSizeChange(val) {
      this.unfinishedPage.pageSize = val;
      this.onLoadRW('wjrwTitle');
    },
    // 快捷方式点击
    pUserShortcutClick(opId, name, item) {
      console.log(item);
      this.loading = true;
      getList({ opid: opId, folderId: "null" }).then(
        res => {
          const data = res.data.data;
          if (data.opsEntities.length == 1) {
            this.$router.replace({
              path: data.opsEntities[0].path,
              query: {
                runId: data.opsEntities[0].runId,
                name: name
              }
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.$router.replace({
              path: this.$router.$avueRouter.getPath({
                name: name,
                src: `/system/public${opId}&null&${name}`
              })
            });
          }
        },
        err => {
          this.loading = false;
        }
      ).catch((err) => { console.log(err) });
    },
    downloadFun(res, name) {
      const blob = new Blob([res.data], {
        type: 'application/octet-stream'
      })
      let url = window.URL.createObjectURL(blob);//为文件流创建构建下载链接
      let link = document.createElement('a');//创建a标签
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);//设置a标签的下载动作和下载文件名
      document.body.appendChild(link);
      link.click();//执行下载
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);//释放标签
    },
    // 点击帮助
    openUrl(it) {
      this.$confirm('确认是否下载《' + it.name + '》文档？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '是',
        cancelButtonText: '否'
      }).then(res => {
        download({
          filePath: "xfjd/upload/doc/20211115/" + it.url + ".pdf",
          fileName: it.name + ".pdf",
        }).then(res => {
          this.downloadFun(res, it.name + ".pdf");
        }).catch((err) => { console.log(err) })
      })
    },
    openscUrl(it){
      this.$confirm('确认是否下载《' + it.TITLE + '》文档？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '是',
        cancelButtonText: '否'
      }).then(res => {
        usualGetFileList({
          runId: this.$route.query.runId,
          businessId: it.ID,
          businessType: "504"
        }).then(rus => {
          let dataArs = rus.data.data.records;
          if(dataArs.length > 0){
            download({
              filePath: 'xfjd/' + dataArs[0].SAVE_NAME,
              fileName: dataArs[0].SHOW_NAME + '.' + dataArs[0].SUFFIX
            }).then(res => {
              this.downloadFun(res, dataArs[0].SHOW_NAME + '.' + dataArs[0].SUFFIX);
            }).catch((err) => { console.log(err) })
          }
        })
      })
    },
    // 获取使用手册帮助列表
    async getSyscData(){
      try {
        this.bzscLoading = true;
        let res = await getShow(1, 999, this.$route.query.runId||this.userInfo.runId, {
          obj: {},
          dwId: 502
        });
        res.data.data.records.forEach(item => {
          if(item.HELP_FJ && item.HELP_FJ.length >= 4 && /\(([^)]*)\)/.exec(item.HELP_FJ)[1] != '0'){
            this.bzscList.push({
              FJSL: Number(item.HELP_FJ[3]),
              ...item
            });
          }
        })
        this.bzscList = this.bzscList.sort((a, b) => a.SORT - b.SORT);
        this.bzscLoading = false;
      } catch (err) {
        this.bzscLoading = false;
        console.log(err, 'getSyscData-----------------------err');
      }
    },
    // 刷新
    async refshClick(num, status,title,refresh) {
      try {
        if(!title) this[status] = true;
        switch (num) {
          case 1:
            await this.onLoadNeed(title,refresh);
            break;
          case 2:
            await this.onLoadMethod(title,refresh);
            break;
          case 3:
            await this.onLoadRW(title,refresh);
            break;
        }
        if(!title) this.$message.success( "刷新成功！" );
        if(!title) this[status] = false;
      } catch (e) {
        if(!title) this.$message.error("刷新失败！" );
        if(!title) this[status] = false;
      };
    },
    // 提醒事项点击标题
    methodClick(row) {
      console.log(row)
      // .RWID || '' ,row.RWZLX || '' ,row.TITLE_URL || '', row.TITLE_OPID || ''
      if (row.RWID) {
        let time = new Date().getTime(),time1 = row.JHKSRQ ? new Date(row.JHKSRQ).getTime() : new Date().getTime();
        let rwlx = ["45","56","67","69","74"]; // 定义任务类型
        let rwflid = ["37"]; // 定义任务分类ID
        if(Number(time - time1) < 0 && (rwlx.includes(row.RWLX) || rwflid.includes(row.RWFLID))){
          if(row.RWFLID == 37){ // 技术服务责令期限届满
            return this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}进行办理`)
          }
          switch (row.RWLX) {
            case '45':// 行政处罚三停责令期限届满
              this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}（不含）开始，三个工作日内进行三停期限届满复查`)
              break;
            case '56'://行政强制解除查封
              this.$message.warning(`请于临时查封期限届满当天（${row.JHKSRQ.split(" ")[0]}）复查`)
              break;
            case '67':// 监督检查责令期限届满
              this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}（不含）开始，三个工作日内进行责令期限届满复查`)
              break;
            case '69':// 重大火灾隐患复查
              this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}进行办理`)
              break;
            case '74':// 安全检查复查申请
              this.$message.warning(`请于复查到期后的三个工作日内进行办理`)
              break;
          }
          return;
        }else{
          this.$router.push({
            path: row.RWZLX == 5 ? "/xfjd/hzdc/fireDetail" : "/xfjd/projectDetail",
            query: {
              runId: this.userInfo.runId,
              RWID: row.RWID,
              path: this.$route.path,
              pagetype: 1,  // 1 办理 , 2  是查看
              parentName: "首页",
            },
          });
        }
      } else if (row.EXEC_URL) {
        this.$router.push({
          path: row.EXEC_URL,
          query: {
            runId: this.userInfo.runId,
            name: row.TITLE,
          },
        });
      } else {
        // this.$message.warning("任务ID不存在!")
      }
    },
    toPage(row, item) {
      console.log(row, item);
      if (item.LINK_PATH) {
        this.$router.push({
          path: item.LINK_PATH,
          query: {
            runId: this.userInfo.runId,
            name: item.BTN_NAME,
          },
        });
      } else if (row.EXEC_URL) {
        this.$router.push({
          path: row.EXEC_URL,
          query: {
            runId: this.userInfo.runId,
            name: row.TITLE,
          },
        });
      } else if (row.RWID) {
        this.$router.push({
          path: row.RWZLX == 5 ? "/xfjd/hzdc/fireDetail" : "/xfjd/projectDetail",
          query: {
            runId: this.userInfo.runId,
            RWID: row.RWID,
            path: this.$route.path,
            pagetype: 1,  // 1 办理 , 2  是查看
            parentName: "首页",
          },
        });
      } else {
        this.$message.warning("任务ID不存在!")
      }
    },
    //本人未结任务点击卡片
    handleTabClick(el) {
      this.search.wjrwTitle = "";
      this.wjrwActiveName = el.name;
      this.unfinishedPage.currentPage = 1
      this.onLoadRW();
    },
    //点击项目名称
    getDetailByXMMC(row) {
      console.log(row);
      let time = new Date().getTime(),time1 = row.JHKSRQ ? new Date(row.JHKSRQ).getTime() : new Date().getTime();
      let rwlx = ["45","56","67","69","74"]; // 定义任务类型
      let rwflid = ["37"]; // 定义任务分类ID
      if(Number(time - time1) < 0 && (rwlx.includes(row.RWLX) || rwflid.includes(row.RWFLID))){
        if(row.RWFLID == 37){ // 技术服务责令期限届满
          return this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}进行办理`)
        }
        switch (row.RWLX) {
          case '45':// 行政处罚三停责令期限届满
            this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}（不含）开始，三个工作日内进行三停期限届满复查`)
            break;
          case '56'://行政强制解除查封
            this.$message.warning(`请于临时查封期限届满当天（${row.JHKSRQ.split(" ")[0]}）复查`)
            break;
          case '67':// 监督检查责令期限届满
            this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}（不含）开始，三个工作日内进行责令期限届满复查`)
            break;
          case '69':// 重大火灾隐患复查
            this.$message.warning(`请于${row.JHKSRQ.split(" ")[0]}进行办理`)
            break;
          case '74':// 安全检查复查申请
            this.$message.warning(`请于复查到期后的三个工作日内进行办理`)
            break;
        }
        return;
      }else{
        if (row.RWID) {
          this.$router.push({
            path: row.RWZLX == 5 ? "/xfjd/hzdc/fireDetail" : "/xfjd/projectDetail",
            query: {
              runId: this.userInfo.runId,
              RWID: row.RWID,
              path: this.$route.path,
              pagetype: 1,  // 1 办理 , 2  是查看
              parentName: "首页",
            },
          });
        } else {
          this.$message.warning("任务ID不存在");
        }
      }
    },
    //获取字典数据
    async getDictData() {
      const [resRWLX, resZRWZT] = await Promise.all([
        getDictionary({ code: "XFJD_XMRW_RWLX" }),
        getDictionary({ code: "XFJD_XMRW_ZRWZT" }),
      ])
      this.optionRW["1"].column[3].dicData = resRWLX.data.data
      this.optionRW["4"].column[3].dicData = resRWLX.data.data
      this.optionRW["7"].column[4].dicData = resRWLX.data.data
      Object.keys(this.optionRW).forEach(key => {
        this.optionRW[key].column.forEach((item, index) => {
          try {
            if (item.prop == "RWZT") {
              item.dicData = resZRWZT.data.data
              throw item
            }
          } catch (item) {
            this.optionRW[key].column[index] = item
          }

        })
      })
      this.resRWFL = resRWLX.data.data
    },
    goPage(path, name) {
      this.$router.push({
        path: path,
        query: {
          runId: this.userInfo.runId,
          name: name
        }
      })
    },
    // 待办事项删除
    // async deletedDbClick(row){
    //   console.log(row);
    //   this.$confirm(`该操作将删除${row.TITLE}待办事项，删除后无法恢复，是否继续操作?`, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
  //       await deleteShow({ id:row.ID, dwId:4682, runId:this.userInfo.runId, type:"change" })
  //       this.$message.success("删除成功!");
  //       this.onLoadNeed("",true);
  //     }).catch((err) => { console.log(err) });
    // },
    // 工作提醒删除
    async deletedsClick(row){
      console.log(row);
      this.$confirm(`该操作将删除${row.TITLE}工作提醒，删除后无法恢复，是否继续操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteShow({ id:row.ID, dwId:3054, runId:this.userInfo.runId, type:"change" }).then(res=>{
          this.$message.success("删除成功!");
          this.onLoadMethod();
        })
      }).catch(() => {});
    }
  },
  filters: {
    formatRWZLX(value, that) {
      console.log(that, 'that.resRWFL---that.resRWFL')
      let obj = that.resRWFL.find(item => { item.dictKey == value })
      return obj.dictValue
    }
  },
  created() {
  },
  mounted() {
    console.log("created");
    this.getDictData();
    this.onLoad();
    this.getSyscData();
  },
  activated() {
    console.log("activated");
    if(this.firstEnter){
      this.firstEnter = false;
    } else {
      this.onLoad();
    }
  } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
/deep/ .avue-crud__pagination {
  display: none;
}
.block {
  overflow: hidden;
  p {
    float: left;
    font-size: 13px;
    color: #606266;
    padding-left: 10px;
  }
  /deep/ .el-pagination {
    float: right;
  }
  span {
    font-size: 13px;
    color: #606266;
    padding-left: 10px;
  }
}
/deep/ .el-table__row td {
  padding: 0;
}
.pUserShortcut {
  width: 100%;
  float: left;
  /* overflow: hidden; */
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  i {
    margin-right: 4px;
  }
  /deep/.tooplTip{
    width: 100% ;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
}
.text-height{
  height: 1.6em;
  line-height: 1.6em;
}
.box-card {
  margin-top: 6px;
  /deep/.el-card__body {
    overflow: hidden;
  }
}
.table_div {
  padding-bottom: 0;
  /deep/ .el-card__body {
    padding: 10px !important;
    padding-bottom: 0 !important;
  }
  /deep/td,
  /deep/th,
  /deep/.cell {
    padding: 0 !important;
  }
  /deep/.el-tabs__header {
    margin: 0 auto;
    width: 99%;
    .is-top > span,
    .is-top > .el-tabs__nav-scroll > .el-tabs__nav > div {
      line-height: 24px;
      height: 24px;
    }
  }
}
/deep/.item .el-button {
  padding: 0px !important;
  font-size: 16px !important;
  color: #303133 !important;
}
/deep/.item .el-badge__content {
  background-color: #f51b1b;
}
/deep/.el-badge__content.is-fixed {
  top: 11px !important;
  right: -1px !important;
}
/deep/.el-aside .el-card__body {
  padding: 6px 10px !important;
}
.refsh-item {
  flex: 1;
  text-align: right;
  color: #2e5ae8;
  cursor: pointer;
}

/deep/.el-col-24{
  width: 100% !important;
}
.box_top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .onload{
    color: #2e5ae8;
    cursor: pointer;
  }
}
.empty{
  text-align: center;
  font-size: 14px;
  color: #909090;
  padding-top: 60px;
  padding-bottom: 20px;
  .icon{
    margin-right:0px !important;
  }
}
</style>
